export function sortObjectEntries(obj: Record<PropertyKey, unknown>) {
  return Object.fromEntries(
    Object.entries(obj).sort(([a], [b]) => a.localeCompare(b)),
  );
}
